import { Component, OnDestroy, OnInit, ChangeDetectorRef } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { Subscription } from "rxjs";
import {
  BaseCategoryTypeEnum,
  ExpenseStatusEnum,
  ProjectBudgetEntityType,
  UserTypeEnum,
} from "src/app/_models";
import {
  SelectBusinessPurposePopupModel,
  SelectCostCentrePopupModel,
  SelectCustomerPopupModel,
  SelectExpenseCategoryPopupModel,
  SelectForignCurrencyPopupModel,
  SelectLocationPopupModel,
  SelectPreApprovalTagPopupModel,
  SelectProjectPopupModel,
  SelectReceiptTypePopupModel,
  SelectStatesPopupModel,
  SelectCompanyPopupModel,
} from "src/app/_models/claimant-on-web/claimant-on-web";
import { SelectAdditionalFieldDataPopupModel } from "src/app/_models/policy/policy-data";
import { UTCDateTime } from "src/app/common/commonvariables";
import { Constants } from "src/util/constants";
import { SelectVehicleModel } from "../../../../_models/claimant-on-web/claimant-on-web";
import { DynamicFormService } from "../../dynamic-form/dynamic-form.service";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";
import { TranslateService } from "@ngx-translate/core";
import { SelectContainerInputModel } from "src/app/_models/container/container";
import { DomSanitizer } from '@angular/platform-browser';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { Claims } from 'src/app/_models/common/claims';
import { SelectVendorBrandInputModel, SelectVendorCategoriesInputModel, VendorDetails } from 'src/app/_models/vendor/vendor.model';
import { VendorCategoryList } from '../../../../_models/vendor/vendor.model';
import { CategoryItem } from '../../../../_models/manage-category/manage-category-list-response';

@Component({
    selector: 'formly-field-input',
    templateUrl: "./formly-input-panel.component.html",
    standalone: false
})
export class FormlyFieldInputPanelComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  get userTypeEnum() {
    return UserTypeEnum;
  }
  inputModel: any;
  showSelectExpenseCategoryPanel: boolean;
  showSelectPreApprovalTagPanel: boolean;
  showSelectForeignCurrencyPanel: boolean;
  showSelectStatesPanel: boolean;
  showSelectBusinessPurposePanel: boolean;
  showSelectAdditionalFieldDataPanel: boolean;
  showExpensePolicyPanel: boolean;
  showSelectCustomerPanel: boolean;
  showSelectProjectPanel: boolean;
  showSelectCostCentrePanel: boolean;
  showSelectReceiptTypePanel: boolean;
  showVehiclePanel: boolean;
  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  openPanelSubscription: Subscription;
  showContainerListPanel: boolean;
  showSelectLocationPanel: boolean;
  showSelectCostCentreForEmployeePanel: boolean;
  fieldKey: string = "InputPanel";

  showVendorCategoriesPanel: boolean = false;
  showVendorBrandMappingPanel: boolean = false;
  showBrandPanel: boolean = false;
  showPolicyInputModel: SelectExpenseCategoryPopupModel;
  alertPanelModel = new AlertPanelModel(
    false,
    "",
    [""],
    "",
    "",
    true,
    this.translate.instant("please_review_or_confirm")
  );
  isCostCentreSelectionHide: boolean = false;
  isLocationSelectionHide = false;
  showCompanyListPanel: boolean = false;
  claims: Claims;
  claimsSubscription: Subscription;
    fmSpecialObject: any;
    showSelectVendorCategoryPanel: boolean;
  constructor(private dynamicFormService: DynamicFormService, private translate: TranslateService, private cdr: ChangeDetectorRef
    ,private sanitizer: DomSanitizer, private claimsService: ClaimsService
  ) {
    super();
    this.claimsSubscription = this.claimsService.currentClaims.subscribe(
      (claims) => {
        this.claims = claims;
      }
    );
  }

  ngOnInit() {
    if (this.field.id) {
      this.fieldKey = this.field.id ?? "InputPanel";
    }
    this.formSubmissionSubscription = this.dynamicFormService
      .getFormSubmittedEvent()
      .subscribe((data) => {
        this.isFormSubmitted = data;
        this.cdr.detectChanges();
      });
    this.openPanelSubscription = this.dynamicFormService
      .getOpenPanelEvent()
      .subscribe((key) => {
        if (key == this.field.key) {
          this.fnOpenSelectionPanel();
        }
      });

    if (this.field && this.field.templateOptions) {
      let isVisibleOnLoad = this.field.templateOptions.isVisibleOnLoad;

      if (
        isVisibleOnLoad &&
        (this.field.key == "expenseCategoryName" ||
          this.field.key == "spentCurrencyCode")
      ) {
        this.fnOpenSelectionPanel();
      }

      this.isCostCentreSelectionHide =
        this.field.templateOptions.isCostCentreSelectionHide;
      this.isLocationSelectionHide =
        this.field.templateOptions.isLocationSelectionHide;
    }
    console.log("MODEL::::::" + this.model)
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
    if (this.openPanelSubscription) {
      this.openPanelSubscription.unsubscribe();
    }
    if (this.claimsSubscription) {
      this.claimsSubscription.unsubscribe();
    }
  }

  fnOpenSelectionPanel() {
    if (
      this.field.key
        .toString()
        .startsWith(Constants.ADDITIONAL_FIELD_DYNAMIC_KEY)
    ) {
      let additionalFieldId = parseInt(
        this.field.key
          .toString()
          .replace(Constants.ADDITIONAL_FIELD_DYNAMIC_KEY, "")
      );
      let additionalFieldValueId =
        this.model[
          this.field.key.toString() + Constants.ADDITIONAL_FIELD_DYNAMIC_ID_KEY
        ];
      this.inputModel = new SelectAdditionalFieldDataPopupModel();
      this.inputModel.additionalFieldDataList =
        this.field.templateOptions.attributes.data;
      this.inputModel.additionalFieldId = additionalFieldId;
      this.inputModel.fieldValueId = additionalFieldValueId;
      this.showSelectAdditionalFieldDataPanel = true;
    } else {
      switch (this.field.key.toString()) {
        case "preApprovalTag":
          this.inputModel = new SelectPreApprovalTagPopupModel();
          this.inputModel.preApprovalId = this.model.preApprovalId;
          this.inputModel.claimantId = this.model.userId;
          this.inputModel.claimantName = this.model.userName;
          this.showSelectPreApprovalTagPanel = true;
          break;
        case "expenseCategoryName":
          this.inputModel = new SelectExpenseCategoryPopupModel();
          this.inputModel.orgExpenseCategoryId =
            this.model.orgExpenseCategoryId;
          this.inputModel.expenseDate = this.model.expenseDate;
          
          let disableBaseCategoryIds = [];
          if (
            this.model.isEditMode &&
            this.model.saveStatus == ExpenseStatusEnum.IncompleteCardExpense
          ) {
            disableBaseCategoryIds.push(BaseCategoryTypeEnum.Mileage);
            disableBaseCategoryIds.push(BaseCategoryTypeEnum.MileageGoogle);
            disableBaseCategoryIds.push(BaseCategoryTypeEnum.MileageGPS);
            if (this.model.amount < 0) {
              disableBaseCategoryIds.push(BaseCategoryTypeEnum.Entertainment);
            }

            this.inputModel.isIncompleteCreditCardExpense = true;
          }
          this.inputModel.disableBaseCategoryIds = disableBaseCategoryIds;
          this.inputModel.claimantId = this.model.userId;
          this.inputModel.claimantName = this.model.userName;
          this.inputModel.baseCategoryId = this.model.baseCategoryId;
          this.inputModel.isFmEditingExpense = this.model.isFmEditingExpense;
          this.inputModel.nrfcStatus = this.model.nrfcStatus;
          this.inputModel.receiptsInfo = this.model.receiptsInfo;

          if (this.model.baseCategoryId && !this.model.isExpenseCategoryActive && this.model.isEditMode){ return;}

          this.showSelectExpenseCategoryPanel = true;
          break;
        case "spentCurrencyCode":
        case "currencyCode":
          if (!this.model.spentCurrencyId) {
            this.model.spentAmount = this.model.amount;
          }
          this.inputModel = new SelectForignCurrencyPopupModel();
          this.inputModel.expenseDate = this.model.expenseDate;
          this.inputModel.currencyId = this.model.currencyId;
          this.inputModel.currencyCode = this.model.currencyCode;
          this.inputModel.spentCurrencyId = this.model.spentCurrencyId;
          this.inputModel.spentCurrencyCode = this.model.spentCurrencyCode;
          this.inputModel.conversionRate = this.model.conversionRate;
          this.inputModel.baseCurrencyIcon = this.model.baseCurrencyIcon;
          this.inputModel.exchangeRateSource = this.model.exchangeRateSource;
          this.inputModel.paymentTypeId = this.model.paymentTypeId;
          this.showSelectForeignCurrencyPanel = true;
          break;
        case "stateName":
          this.inputModel = new SelectStatesPopupModel();
          this.inputModel.stateId = this.model.stateId;
          this.inputModel.stateName = this.model.stateName;
          this.showSelectStatesPanel = true;
          break;
        case "bpValue":
          this.inputModel = new SelectBusinessPurposePopupModel();
          this.inputModel.bpId = this.model.bpId;
          this.inputModel.bpValue = this.model.bpValue;
          this.inputModel.businessPurposeCaption =
            this.field.templateOptions.label.replace("Select ", "");
          this.showSelectBusinessPurposePanel = true;
          break;
        case "vatNoVatReceiptType":
          this.to.click(this.field, "vatNoVatReceiptType");
          this.inputModel = new SelectReceiptTypePopupModel();
          this.inputModel.vatNoVatReceiptTypeId =
            this.model.vatNoVatReceiptTypeId;
          this.inputModel.options = this.field.templateOptions.options;
          this.showSelectReceiptTypePanel = true;
          break;
        case "derivedName":
          this.inputModel = new SelectVehicleModel();
          this.inputModel.vehicleId = this.model.mileage.vehicleId;
          this.inputModel.derivedName = this.model.mileage.derivedName;
          this.inputModel.registrationNumber = this.fnReturnRegNum(
            this.model.mileage.registrationNumber
          );
          this.inputModel.makeModel = this.fnReturnMakeModel(
            this.model.mileage.makeModel
          );
          this.inputModel.claimantId = this.model.userId;
          this.inputModel.claimantName = this.model.userName;

          this.inputModel.options = this.field.templateOptions.options;
          let todaysDate = this.getUTCTimeStamp(new Date());
          let expenseDateUnix = this.getUTCTimeStamp(
            new Date(this.model.expenseDate)
          );
          if (expenseDateUnix < todaysDate) {
            this.fnDisplayAlertPanel();
          } else {
            this.showVehiclePanel = true;
          }

          break;
        case "customerName":
          this.inputModel = new SelectCustomerPopupModel();
          this.inputModel.customerId = this.model.customerId;
          this.showSelectCustomerPanel = true;
          break;
        case "newCostCentreName":
          this.inputModel = new SelectCostCentrePopupModel();
          this.inputModel.costCentreId = this.model.newCostCentreId;
          this.inputModel.isSelectionHide = this.isCostCentreSelectionHide;
          this.showSelectCostCentrePanel = true;
          break;
        case "costCentreCode1":
          this.to.click(this.field, "costCentreCode1");
          this.inputModel = new SelectCostCentrePopupModel();
          this.inputModel.costCentreId = this.model.costCentreId;
          this.inputModel.costCentreName = this.model.costCentreName;
          this.fmSpecialObject = {
            type: 1,
          };
          this.showSelectCostCentreForEmployeePanel = true;
          break;
        case "newLocationName":
          this.inputModel = new SelectLocationPopupModel();
          this.inputModel.locationId = this.model.newLocationId;
          this.inputModel.isSelectionHide = this.isLocationSelectionHide;
          this.showSelectLocationPanel = true;
          break;
        case "entityName":
        case "projectName":
          this.inputModel = new SelectProjectPopupModel();
          this.inputModel.entityId = this.model.entityId;
          this.inputModel.projectDetailsId = this.model.projectDetailsId;

          this.inputModel.isCostCentrePackagePurchasedOrTrial =
            this.model.isCostCentrePackagePurchasedOrTrial;
          this.inputModel.isCustomerPackagePurchasedOrTrial =
            this.model.isCustomerPackagePurchasedOrTrial;
          this.inputModel.isProjectBudgetPurchasedOrTrial =
            this.model.isProjectBudgetPurchasedOrTrial;
          this.inputModel.claimantId = this.model.userId;
          this.inputModel.claimantName = this.model.userName;

          this.showSelectProjectPanel = true;
          break;
        case "containerName":
          this.inputModel = new SelectContainerInputModel();
          this.inputModel.claimantId = this.model.userId;
          this.inputModel.containerId = this.model.containerId;
          this.inputModel.containerName = this.model.containerName;
          this.showContainerListPanel = true;
          break;
        case "companyName":
          this.inputModel = new SelectCompanyPopupModel();
          this.inputModel.claimantId = this.model.userId;
          this.inputModel.companyId = this.model.companyId;
          this.inputModel.companyName = this.model.companyName;
          this.inputModel.cardCompanyId = this.model.cardCompanyId;
          this.inputModel.cardCompanyName = this.model.cardCompanyName;
          this.inputModel.financeManagerId = this.model.financeManagerId;
          this.inputModel.financeManagerName = this.model.financeManagerName;
          this.inputModel.financeManagerEmail = this.model.financeManagerEmail;
          this.showCompanyListPanel = true;
              break;
          case 'vendorCategories':
              this.inputModel = new SelectVendorCategoriesInputModel();
              this.inputModel.assignedCategoryIdsList = this.model.assignedCategories ? this.model.assignedCategories : [];
              this.showVendorCategoriesPanel = true;
              break;
          case 'vendorBrands':
              this.inputModel = new SelectVendorBrandInputModel();
              this.inputModel.assignedIdsList = this.model.assignedBrands;
              this.showVendorBrandMappingPanel = true;
              break;
          case 'brandName':
              this.inputModel = {
                  itemBrandId: this.model.itemBrandId
              }
              this.showBrandPanel = true;
              break;
          case 'vendorCategoryName':
              this.inputModel = {
                  orgExpenseCategoryId: this.model.orgExpenseCategoryId,
                  vendorCategoryName: this.model.vendorCategoryName,
                  type: 'vendorCategoryName'
              }
              this.showSelectVendorCategoryPanel = true;
              break;
          case 'vendorCategoryItemName':
              this.inputModel = {
                  categoryItemId: this.model.categoryItemId,
                  orgExpenseCategoryId: this.model.orgExpenseCategoryId,
                  name: this.model.name,
                  type: 'vendorCategoryItemName'
              }

              this.showSelectVendorCategoryPanel = true;
              break;
          case 'purchaseOrderNumber':
              this.inputModel = {
                  purchaseOrderNumber: this.model.purchaseOrderNumber,
                  purchaseOrderId: this.model.purchaseOrderId,
                  type: 'purchaseOrderNumber'
              }
              this.showSelectVendorCategoryPanel = true;
              break;
      }
    }
  }
  getUTCTimeStamp(date) {
    let now_utc = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0
    );

    return now_utc;
  }
  fnDisplayAlertPanel() {
    this.alertPanelModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [this.translate.instant("past_date_selected_veh_msg1")],
      "",
      this.translate.instant("oK_text"),
      true,
      ""
    );
  }
  alertPanelReceiver(returnValue) {
    this.alertPanelModel = new AlertPanelModel(
      false,
      "",
      [""],
      "",
      "",
      true,
      this.translate.instant("please_review_or_confirm")
    );
  }
  closeSelectionPanel(isClose) {
    if (isClose) {
      this.hidePanel();
    }
  }

  onSelection(data) {
    let value = data.value;

    if (this.field.key == "preApprovalTag") {
      this.model.preApprovalId = data.preApprovalId;
      this.model.preApprovalTag = data.preApprovalTag;
      this.model.preApprovalBalance = data.preApprovalBalance;
      value = data.preApprovalTag;
    } else if (this.field.key == "expenseCategoryName") {
      value = data.expenseCategoryName;
      this.model.customFields = data.customFields;
      this.model.categoryAdditionalFieldData = data.categoryAdditionalFieldData;
      this.model.isNotesMandatory = data.isNotesMandatory;
      this.model.isCFPReporting = data.isCFPReporting;
      this.model.baseCategoryId = data.baseCategoryId;
      this.model.orgSubCategoryMappings = data.orgSubCategoryMappings;
      data.amount = this.model.amount;
      data.receiptsInfo = this.model.receiptsInfo;
      data.expenseDate = this.model.expenseDate;
      data.supplier = this.model.supplier;
      data.receiptNumber = this.model.receiptNumber;
      data.spentCurrencyId = this.model.spentCurrencyId;
      data.spentCurrencyCode = this.model.spentCurrencyCode;
      data.spentAmount = this.model.spentAmount;
      data.conversionRate = this.model.conversionRate;
    } else if (this.field.key === "spentCurrencyCode") {
      value = data.spentCurrencyCode;
    } else if (this.field.key === "currencyCode") {
      value = data.currencyCode;
    } else if (this.field.key == "bpValue") {
      value = data.bpValue;
      this.model.bpId = data.bpId;
    } else if (this.field.key == "stateName") {
      value = data.stateName;
      this.model.stateId = data.stateId;
      this.model.stateName = data.stateName;
    } else if (
      this.field.key
        .toString()
        .startsWith(Constants.ADDITIONAL_FIELD_DYNAMIC_KEY)
    ) {
      value = data.fieldValue;
    } else if (this.field.key == "vatNoVatReceiptType") {
      value = data.vatNoVatReceiptType;
      this.model.vatNoVatReceiptType = data.vatNoVatReceiptType;
      this.model.vatNoVatReceiptTypeId = data.vatNoVatReceiptTypeId;
    } else if (this.field.key == "customerName") {
      value = data.customerName;
      this.model.customerId = data.customerId;
      this.model.customerName = data.customerName;
    } else if (this.field.key == "newCostCentreName") {
      value = data.costCentreName;
      this.model.newCostCentreId = data.costCentreId;
      this.model.newCostCentreName = data.costCentreName;
    } else if (this.field.key == "derivedName") {
      value = data.derivedName;
      this.model.mileage.vehicleId = data.vehicleId;
      this.model.mileage.registrationNumber = this.fnReturnRegNum(
        data.registrationNumber
      );
      this.model.mileage.makeModel = this.fnReturnMakeModel(data.makeModel);
      this.model.mileage.derivedName = data.derivedName;
      this.model.mileage.vehicleTypeId = data.vehicleTypeId;
      this.model.mileage.orgVehicleTypeMapId = data.orgVehicleTypeMapId;
      this.model.mileage.mileageAllowance = data.mileageAllowance;
      this.model.mileage.docStatus = data.docStatus;
    } else if (
      this.field.key == "entityName" ||
      this.field.key == "projectName"
    ) {
      value = data[this.field.key];
      this.model.customerId =
        data.entityType == ProjectBudgetEntityType.Customer ? data.entityId : 0;
      this.model.customerName =
        data.entityType == ProjectBudgetEntityType.Customer
          ? data.entityName
          : null;
      this.model.projectDetailsId = data.projectDetailsId;
      this.model.projectName = data.projectName;
      this.model.projectBudgetDetailsId = data.projectBudgetDetailsId;
      this.model.newCostCentreId =
        data.entityType == ProjectBudgetEntityType.CostCentre
          ? data.entityId
          : 0;
      this.model.entityId = data.entityId;
      this.model.entityType = data.entityType;
      this.model.entityName = data.entityName;
    } else if (this.field.key == "containerName") {
      value = data[this.field.key];
      this.model.containerId = data.containerId;
      this.model.containerName = data.containerName;
      this.model.preApprovalId = data.preApprovalId;
    } else if (this.field.key == "newLocationName") {
      value = data.locationName;
      this.model.newLocationId = data.locationId;
      this.model.newLocationName = data.locationName;
    } else if (this.field.key == "companyName") {
      value = data[this.field.key];
      this.model.companyId = data.companyId;
      this.model.companyName = data.companyName;
      this.model.companyJustificationNotes = data.companyJustificationNotes;
    } else if (this.field.key == "costCentreCode1") {
      value = data.costCentreName;
      this.model.costCentreId = data.costCentreId;
      this.model.costCentreName = data.costCentreName;
      this.model.isCostCentreOn = this.claims.isCostCentreOn;
      }
    else if (this.field.key == 'vendorCategories') {
        value = data.assignedCategoriesName;
        this.model.assignedCategories = data.assignedCategoryIdsList;
    }
    else if (this.field.key == 'vendorBrands') {
        value = data.assignedName;
        this.model.assignedBrands = data.assignedIdsList;
    }
    else if (this.field.key == 'brandName') {
        value = data.brandName;
        this.model.itemBrandId = data.itemBrandId;
    }
    else if (this.field.key == 'vendorCategoryName') {
        value = data.vendorCategoryName;
        this.model.orgExpenseCategoryId = data.orgExpenseCategoryId;
        this.model.vendorCategoryName = data.vendorCategoryName;
    }
    else if (this.field.key == 'vendorCategoryItemName') {
        value = data.vendorCategoryItemName;
        this.model.categoryItemId = data.categoryItemId;
        this.model.vendorCategoryItemName = data.vendorCategoryItemName;
        this.model.receiptInfo = data.receiptInfo;
    }
    else if (this.field.key == 'purchaseOrderNumber') {
        value = data.purchaseOrderNumber;
        this.model.purchaseOrderNumber = data.purchaseOrderNumber;
        this.model.purchaseOrderId = data.purchaseOrderId;
    }

    this.formControl.setValue(value);
    this.to.change(this.field, data);
    this.hidePanel();
  }

  hidePanel() {
    this.showSelectForeignCurrencyPanel = false;
    this.showSelectExpenseCategoryPanel = false;
    this.showSelectPreApprovalTagPanel = false;
    this.showSelectStatesPanel = false;
    this.showSelectBusinessPurposePanel = false;
    this.showSelectAdditionalFieldDataPanel = false;
    this.showExpensePolicyPanel = false;
    this.showSelectCustomerPanel = false;
    this.showSelectCostCentrePanel = false;
    this.showSelectCostCentreForEmployeePanel = false;
    this.showSelectProjectPanel = false;
    this.showSelectReceiptTypePanel = false;
    this.showVehiclePanel = false;
    this.showContainerListPanel = false;
    this.showSelectLocationPanel = false;
      this.showCompanyListPanel = false;
      if (this.field.key == 'costCentreCode1') {
          this.model.isCostCentreOn = this.claims.isCostCentreOn;
      }
      this.showVendorCategoriesPanel = false;
      this.showVendorBrandMappingPanel = false;
      this.showBrandPanel = false;
      this.showSelectVendorCategoryPanel = false;
  }

  fnShowExpPolicy() {
    if (this.model.orgExpenseCategoryId) {
      this.showPolicyInputModel = new SelectExpenseCategoryPopupModel();
      this.showPolicyInputModel.orgExpenseCategoryId =
        this.model.orgExpenseCategoryId;
      this.showPolicyInputModel.expenseCategoryName =
        this.model.expenseCategoryName;
      this.showPolicyInputModel.claimantId = this.model.userId;
      this.showPolicyInputModel.expenseDate = new Date(
        UTCDateTime.getUTCDate(new Date(this.model.expenseDate))
      ).valueOf();
      this.showExpensePolicyPanel = true;
    }
  }
  fnReturnRegNum(registrationNumber) {
    let regNum = "";
    if (
      registrationNumber == "" ||
      registrationNumber == null ||
      !registrationNumber
    ) {
      regNum = "-";
    } else {
      regNum = registrationNumber;
    }
    return regNum;
  }
  fnReturnMakeModel(makeModel) {
    let makeMod = "";
    if (makeModel == "" || makeModel == null || !makeModel) {
      makeMod = "";
    } else {
      makeModel = makeModel.replace("(", "");
      makeModel = makeModel.replace(" ", "");
      makeModel = makeModel.replace(")", "");
      makeMod = " (" + makeModel + ")";
    }
    return makeMod;
  }
  sanitizerHtml(htmlCustomMsg) {
    if (htmlCustomMsg) {
      let safeText = this.sanitizer.bypassSecurityTrustHtml(htmlCustomMsg);
      return safeText;
    } else {
      return "&nbsp";
    }
  }

  fnOpenCostCentrePanel() {
    this.fmSpecialObject = {
      type: 1,
    };
    this.inputModel = new SelectCostCentrePopupModel();
    this.inputModel.costCentreId = this.model.costCentreId || 0;
    this.inputModel.costCentreName = this.model.costCentreName || "";
    this.showSelectCostCentreForEmployeePanel = true;
  }
  fnOpenSupportingNotePanel() {
    this.to.click(this.field, "supportingNote");
  }
  fnOpenReceiptTypePanel() {
    this.to.click(this.field, "receiptTypeSetup");
  }
}
